import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'procure-form-row',
  templateUrl: './form-row.component.html',
  styleUrl: './form-row.component.scss',
  host: {
    '[class.standalone]': 'standalone',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Necessary to allow styling of projected content
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class FormRow {
  readonly standalone = input<boolean>(false);
}
